import React, { useState } from 'react';
import HamburgerMenu from 'react-hamburger-menu';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import useAuth from '../../../../hooks/useAuth';
import Icon from '../../../Icon';
import TheInsideLogo from '../../../svgs/TheInsideLogo';
import Cart from '../../common/Cart';
import MenuMobile from './menuMobile/MenuMobile';

const Wrapper = styled.div`
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  background: white;
  position: relative;
  z-index: 1002;

  .hamburger-menu {
    z-index: 1001;
    position: absolute;
    top: 11px;
    left: 12px;
    span {
      background-color: black;
    }
  }

  .contact-about-coupon-container,
  .search-login-cart-side {
    display: flex;
    align-items: center;
  }

  .container {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }

  .right-side-container,
  .left-side-container {
    width: 40%;
  }

  .logo-nav-mobile {
    width: 49px;
    height: auto;
  }

  .logo {
    width: 33.3%;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .nav-link {
    color: ${({ theme }) => theme.colors.charcoal};
    &:hover {
      color: ${({ theme }) => theme.colors.charcoal};
    }
  }

  .right-side-container,
  .left-side-container {
    display: flex;
    align-items: center;
  }

  .right-side-container {
    margin-right: 10px;
    justify-content: flex-end;
  }

  .search-btn-container {
    padding-left: 60px;
  }

  .left-side-container {
    margin-left: 10px;
    justify-content: flex-start;
  }
  .sign-in {
    svg {
      height: 25px;
      width: 25px;
    }
  }

  .search {
    svg {
      width: 28px;
      height: 28px;
    }
    line {
      stroke-width: 6px;
    }
    path {
      stroke-width: 6px;
    }
  }
`;

function NavTop({ setShowSearch }) {
  const user = useSelector(state => state.Auth.user);
  const history = useHistory();
  const [toggle, setToggle] = useState(false);
  const [login, logout, { loading, error, data, isAuthenticated }] = useAuth();

  const handleLogout = () => {
    logout();
    history.push(`/`);
  };
  const handleHamburger = () => {
    setToggle(!toggle);
  };

  const closeMenu = () => {
    setToggle(false);
  };

  return (
    <Wrapper>
      <MenuMobile toggle={toggle} closeMenu={closeMenu} />
      <div className="container">
        <div className="left-side-container">
          <div className="hamburger-menu hide-on-desktop">
            <HamburgerMenu
              className="hamburger-menu"
              isOpen={toggle}
              menuClicked={handleHamburger}
              width={30}
              height={20}
              strokeWidth={1}
              rotate={0}
              color="#000 !important"
              borderRadius={0}
              animationDuration={0.3}
            />
          </div>
          <div className="search-btn-container">
            <div className="search" onClick={() => setShowSearch(true)}>
              <Icon icon="ti-search" size={20} color="black" />
            </div>
          </div>
        </div>
        <div className="logo">
          <Link to="/" aria-label="The Inside">
            {/* <TheInsideLogoHolidays isScrolling={true} /> */}
            <TheInsideLogo className="logo-nav-mobile" isScrolling={true} />
          </Link>
        </div>
        <div className="right-side-container">
          <div className="search-login-cart-side">
            <div className="sign-in">
              <Link
                to={isAuthenticated ? '/account' : '/login'}
                className="nav-link"
              >
                <Icon
                  icon="ti-account"
                  className="mr-1"
                  size={20}
                  color="black"
                />
              </Link>
            </div>

            <Cart />
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default NavTop;
